import { Pagination } from '@calizahq/react-components-v2'
import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import React, { FC } from 'react'

type Props = {
  currentPage?: number
  resultsPerPage?: number
  totalPages?: number
  totalResults?: number
}

export const ListPagination: FC<Props> = ({
  currentPage = 1,
  resultsPerPage = 1,
  totalPages = 1,
  totalResults = 0,
}) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()

  if (totalPages === 1) {
    return null
  }

  function handleChange(page: number) {
    if (page !== currentPage) {
      WorkspaceDispatch(WorkspaceAction.updateFilters({ currentPage: page }))

      scroll({
        top: 0,
        behavior: 'smooth',
      })
    }
  }
  return (
    <div className="mt-6 flex w-full justify-center">
      <Pagination
        currentPage={currentPage}
        onChange={handleChange}
        // renderPaginationItem={renderPaginationItem}
        resultsPerPage={resultsPerPage}
        totalPages={totalPages}
        totalResults={totalResults}
      />
    </div>
  )
}
